import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import SignatureCanvas from 'react-signature-canvas';
import PDF from './PDF2';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import DocsListForManager from '../NavTabs/DocsListForManager';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import * as actions from '../../store/actions/index';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import ReactCodeInput from 'react-verification-code-input';
import axios from 'axios';
import { message } from 'antd';

const styles = theme => ({
    body:{
        backgroundColor: 'grey',
    },
    container: {
        width: '80vw',
        height: '47vh',
        // margin:'10%',
        // alignItem: 'center',
        // margin: '0 Auto',
    },
    containerB: {
        width: '80vw',
        height: '12vh',
        // margin:'10%',
        // alignItem: 'center',
        // margin: '0 Auto',
    },
    containerC:{
        minHeight:'100vh'
    },
    sigContainer: {
        height: '100%',
        width:'100vw',
        // alignItems:'center',
        backgroundColor: '#fff',
    },
    sigPad:{
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
    },
    button: {
        //width: '100%',
        padding:'5px',
        margin:'10px'
    },
    sizeSmall:{
        fontSize: '10px',
    },
    sigImage: {
        backgroundSize: '200px 50px',
        width: '200px',
        height: '200px',
        backgroundColor: 'white',
    },
    pdfMargin:{
        // paddingRight: 10
    },
    bInput: {
        background: "rgba(255, 255, 255, 0.5)",
        outline: "0",
        color: "#99192D",
        // wordWrap: "break-word",
        // wordBreak: "break-all",
        border: "2px solid #99192D",
        textTransform: 'none',
        paddingTop: "15px",
        paddingBottom: "15px",
        borderRadius: "25px",
        // height: "30px",
        marginLeft: "3px",
        marginRight: "3px",
        boxSizing: "border-box",
        fontSize: "16px",
        "&:hover": {
            color: "white",
          },
      },
      root: {
        height: "100vh",
        padding:"3%",
        '@media (max-width: 480px)': {
            height: '75vh'
        },
        '@media (max-width: 510px)': {
          height: '80vh'
        }
      },
      containerStyle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh', // Full height to center vertically
        textAlign: 'center', // Center text
      }
});

class SignatureCanvasWrapperForManagerSign extends Component{

    state = {
        trimmedDataURL: null,
        uniqueId: this.props.match.params.uniqueId,
        fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.match.params.conversationId}`,
        signSubmitted:true,
        isSpecialSignatureVerified: true,
        signatureNotFound: false,
        waitingForSignatureUpdate: false,
        isSigned: false,
        caseData: {},
        verifyCode: '',
        message: '',
        isCodeSent: false,
    }
  
    sendVerifyCode = async () => {
      try {
        const response = await axios.post('/api/send-verify-code');
        if (response.data.success) {
          this.setState({
            isCodeSent: true,
          })
        }
      } catch (error) {
        this.setState({
            isCodeSent: true,
        })
      }
    };

    clearToken = async () => {
        try {
          const response = await axios.post('https://www.hkarbsoc.org.hk:9000/clearTokenForSignature', { 'caseId': this.props.match.params.caseId, 'token': this.props.match.params.token, "payment_details":{ "timestamp":"", "paid": "manually paid" }, "userType":"claimant"});
          if (response.data == 'added') {
            window.location.href = '/';
          }
        } catch (error) {
          alert('Error confirming signature. Please try again.');
        }
      };

    checkTokenValid = async () => {
        try {
          const response = await axios.post('https://www.hkarbsoc.org.hk:9000/checkTokenValidity',{ 'caseId': this.props.match.params.caseId, 'token': this.props.match.params.token });
          console.log('checkTokenValid response: '+JSON.stringify(response.data))
          if (response.data == 'error') {
            window.location.href = '/';
            return false;
          }
          else{
            axios.post('https://www.hkarbsoc.org.hk:9000/getCaseInfo', {
                'caseId': this.props.match.params.caseId
              })
            .then((response) => {
                console.log('getCaseInfo response: '+JSON.stringify(response.data))
                this.setState({
                    caseData: response.data
                })
    
                if(localStorage.getItem('language') !== (response.data.language == "Eng" ? 'en' : "cn")){
                    if(response.data.language == 'Chi'){
                        localStorage.setItem('language', 'cn');
                    }
                    else if(response.data.language == 'Eng'){
                        localStorage.setItem('language', 'en');
                    }
                    setTimeout(()=>{
                        window.location.reload();
                    },100)
                }
            })
            .catch((error) => {
                console.log(error);
            });
          }
        } catch (error) {
          window.location.href = '/';
          return false;
        }
      };
  
    submitVerifyCode = async () => {
      try {
        const response = await axios.post('/api/verify-code', { code: this.state.verifyCode });
        if (response.data.success) {
            this.setState({
                message: 'Verification successful!',
                isSpecialSignatureVerified: true,
            })
        } else {
            this.setState({
                message: 'Verification code not correct.',
            })
        }
      } catch (error) {
        this.setState({
            message: 'Error verifying code.',
            isSpecialSignatureVerified: true,
        })
      }
    };

    sigPad={};

    clear = (name) => {
        this.sigPad[name].clear()
        this.setState({
            signatureNotFound:false
        })
    }

    trim = (name) => {
        this.setState({ waitingForSignatureUpdate : true })
        console.log('Trimming name: '+name)
        console.log('Trimming name: '+JSON.stringify(name))
        let base_data = this.sigPad[name].getTrimmedCanvas().toDataURL('image/png');
        console.log('base_data: '+base_data)
        var len = (''+base_data).length
        var y = 0;
        if ( (''+base_data).includes('==')){
            y = 2
        }
        else if ( (''+base_data).includes('=')){
            y = 1
        }

        var kb = ((len * (3/4))-y)/1000

        if (kb <= 2){
            this.setState({
                signatureNotFound:true
            })
        }
        else{
            this.setState({
                signatureNotFound:false
            })
            this.setState({trimmedDataURL : base_data.split(',')[1]});

            let userType = 'claimant';


            if (this.state.caseData.agreement_type == 'EstateAgentDispute' && userType == 'respondent'){
                if ("claimant" == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${"claimant"}_signature_${name.toLowerCase()}.png`,
                        "claimant",
                        name,
                        base_data
                    );
                }
            }
            else if (this.state.caseData.agreement_type == 'SalesOfGoods'){
                if ("claimant" == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${"claimant"}_signature_${name.toLowerCase()}.png`,
                        "claimant",
                        name,
                        base_data
                    );
                }
            }
            else if (this.state.caseData.agreement_type == 'serviceDispute'){
                if ("claimant" == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${"claimant"}_signature_${name.toLowerCase()}.png`,
                        "claimant",
                        name,
                        base_data
                    );
                }
            }
            else if (this.state.caseData.agreement_type == 'insuranceDispute'){
                if ("claimant" == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${"claimant"}_signature_${name.toLowerCase()}.png`,
                        "claimant",
                        name,
                        base_data
                    );
                }
            }
            else{
                if ("claimant" == 'user'){
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${userType}_signature.png`,
                        userType,
                        name,
                        base_data
                    );
                }
                else{
                    this.props.uploadSignature(
                        this.props.match.params.caseId,
                        `${this.props.match.params.conversationId}_${"claimant"}_signature.png`,
                        "claimant",
                        name,
                        base_data
                    );
                }
            }

            this.setState({
                fileURL:"",
                signSubmitted:false
            })  
            var self = this
            setTimeout(()=>{
                console.log('FORCING UPDATE')
                let userType = 'claimant';
                this.setState({
                    fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.match.params.conversationId}`
                })  
                
                self.setState({ waitingForSignatureUpdate : false })
            },50000)
        }
    
    }
   
    componentWillMount(){
        this.updateFileURL();
    }
    handleCodeChange = vals => {
        this.setState({ verifyCode: vals });
    };
    componentDidMount(){
       this.checkTokenValid();
    }

    updateFileURL(){
        this.setState({
            fileURL:""
        })  

        setTimeout(()=>{
            console.log('FORCING UPDATE')
            try{
            this.sigPad.clear()
            } catch(err){}
            this.setState({
                fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.match.params.conversationId}`
            })
        },2000)
    }
    
    render(){
        const { classes } = this.props;
        console.log('this.props.match.params.token: '+this.props.match.params.token, ' this.props.match.params.conversationId: '+this.props.match.params.conversationId)
        if(this.state.isSpecialSignatureVerified == false){
            if(!this.state.isCodeSent){
                return(<div className={classes.containerStyle}>
                     <Typography gutterButtom variant="subtitle1" component="p" style={{color:'#B71C1C', marginTop:'10px',}}>
                        {this.context.t( "Please press 'RECEIVE CODE' to get a verification code" )}
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={()=>{this.sendVerifyCode()}}
                        type="submit"
                        color="primary"
                        style={{marginTop:'30px', textTransform:'uppercase'}}
                        disabled={this.state.loginInProgress}
                        className={classes.bInput}
                    >
                        {this.context.t("Receive Code")}
                    </Button>
                </div>)
            }
            else{
                return(
                    <div className={classes.containerStyle}>
                        <div>
                        <p style={{fontWeight:'bold'}}>
                            {this.context.t('Please Enter the Verification Code')}
                        </p>

                        <ReactCodeInput
                            fieldWidth={ this.props.isDesktop ? "5%" : "10%"}
                            value={this.state.verifyCode}
                            onChange={this.handleCodeChange}
                        />
                        <Button
                            variant="contained"
                            onClick={()=>{this.submitVerifyCode()}}
                            color="primary"
                            style={{marginTop:'30px', textTransform:'uppercase'}}
                            >
                            {this.context.t("Submit")}
                        </Button>
                        </div>
                        {message && <p className='mt-3'>{this.state.message}</p>}
                    </div>
                )
            }
        }
        else if(this.state.isSigned){
            return(<div className={classes.containerStyle}>
                 <Typography gutterButtom variant="subtitle1" component="p" style={{color:'#B71C1C', marginTop:'10px', fontWeight:'bold', fontSize:'25px'}}>
                        {this.context.t( "Thank you. Signature is saved." )}
                    </Typography>
            </div>)
        }
        else{
            return(
                <div>
                    <Grid container alignItems="center" justify="center" className={classes.root} direction='row'>
                        {this.state.signatureNotFound && <h4 style={{display: 'block', width: '79%', textAlign: 'left', margin: '0 Auto'}}>{this.context.t('The signature cannot be identified, please sign again.')}<br></br><br></br></h4>}
                        
                        <Card className={classes.container}>
                            <div className={classes.sigContainer}>
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', fontSize:'15px', color:'#99192D'}}>{this.context.t('Please provide your signature below')}</h4><br></br>
                                <SignatureCanvas
                                    clearOnResize={false}
                                    canvasProps={{className: classes.sigPad}}
                                    ref= {(ref) => { this.sigPad['a'] = ref }}
                                />
                            </div>
                        </Card><br></br>
                        <div style={{display: 'block', textAlign: '-webkit-center'}}>
                                <br></br>
                                <Button
                                    disabled
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    style={{background:'white', color:'black', textTransform:'none'}}
                                    onClick={this.props.handleComplete}
                                >
                                    {this.context.t('I certify that information contained in the Arbitration Notice is true and correct.')}
                                </Button><br></br><br></br>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.bInput}
                                    // classes={{ root: classes.button }}
                                    onClick={this.clear.bind(this,'a')}
                                    // size='small' //assign  it small if its a mobile screen
                                    >
                                    {this.context.t('Reset')}
                                </Button><br></br><br></br>
                                {!this.state.waitingForSignatureUpdate && <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.bInput}
                                    // onClick={this.trim}
                                    onClick={this.trim.bind(this, 'a')}
                                >
                                    {this.context.t('Submit')}
                                </Button>}
                                {this.state.waitingForSignatureUpdate && <CircularProgress
                                    size={50}
                                    thickness={3}
                                    className={classes.progress}
                                />}
                                <br></br><br></br>
                                <Button
                                    disabled = {this.state.signSubmitted}
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.bInput}
                                    onClick={()=>{ this.clearToken() }}
                                >
                                    {this.context.t('Confirm Signature')}
                                </Button>
                        </div>
                        <PDF isDesktop={this.props.isDesktop} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                    </Grid>   
                </div>
            );
        }
            
    }


    
}

const mapStateToProps = (state) => {
    return {
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
        uploadSignature: (caseId, file_name, userType, name, base_data) => dispatch(actions.uploadSignature(caseId, file_name, userType, name, base_data)),
    }
  }

  const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

  SignatureCanvasWrapperForManagerSign.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withSizes(mapSizesToProps) (withRouter(SignatureCanvasWrapperForManagerSign))) );